import { z } from 'zod';
import { optionalUuidArray, optionalUuidString } from '../zod-helpers/index.js';
export const itemFilterSchema = z.object({
    brandIds: optionalUuidArray('Invalid brand selection.').nullish(),
    categoryIds: optionalUuidArray('Invalid category selection.').nullish(),
    uncategorized: z.boolean().nullish(),
    locationGroupIds: optionalUuidArray('Invalid warehouse selection.').nullish(),
    locationId: optionalUuidString('Invalid location selection.').nullish(),
    partId: optionalUuidString('Invalid part selection.').nullish(),
    stateIds: optionalUuidArray('Invalid state selection.').nullish(),
});
//# sourceMappingURL=item-filter.js.map